<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>

        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <input id="search" v-model="filter.search" type="text" class="form-control" placeholder="Search...">
                </div>
            </div>
            <div class="col-md-4" />
            <div class="col-md-2">
                <b-button id="create" variant="primary" class="btn-block" @click="$router.push({ name: 'navbar.mapping' })">
                    Mapping
                </b-button>
            </div>
            <div class="col-md-2">
                <b-button id="create" v-b-modal.form-modal variant="primary" class="btn-block" @click="cleanUpForm()">
                    Create
                </b-button>
            </div>
        </div>

        <b-card-code no-body>
            <div class="table-responsive-sm">
                <table class="table b-table table-fixed">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Link Type</th>
                            <th>Partner</th>
                            <th>Content</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="isLoading">
                            <td colspan="5" class="text-center">
                                <b-spinner label="Loading..." variant="primary" />
                            </td>
                        </tr>
                        <template v-if="!isLoading">
                            <tr v-for="item, index in result.items" :key="index">
                                <td>{{ item.title || '-' }}</td>
                                <td>{{ item.link_type || '-' }}</td>
                                <td>{{ item.partner ? item.partner.name : '-' }}</td>
                                <td>
                                    <div v-if="item.link_type == 'url'">
                                        {{ item.url }}
                                    </div>
                                </td>
                                <td class="text-right">
                                    <div class="btn-group" role="group" aria-label="Basic example">

                                        <b-button id="edit" variant="info" class="btn-sm" style="margin-left: 2px;"
                                            data-toggle="tooltip" data-placement="top" title="Edit"
                                            @click="editItem(item)">
                                            <feather-icon icon="EditIcon" />
                                        </b-button>

                                        <b-button id="delete" variant="danger" class="btn-sm" style="margin-left: 2px;"
                                            data-toggle="tooltip" data-placement="top" title="Delete"
                                            @click="deleteItem(item._id)">
                                            <feather-icon icon="Trash2Icon" />
                                        </b-button>

                                    </div>
                                </td>
                            </tr>
                            <tr v-if="totalItems == 0">
                                <td colspan="5" class="text-center">
                                    Data is empty.
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>

                <div class="row mt-1 mx-0">
                    <div class="col-6 pl-2">
                        <small>Showing {{ Math.min(perPage * currentPage, totalItems) }} to {{ totalItems || 0 }} from
                            {{ totalRows || 0
                            }}
                        </small>
                    </div>
                    <div class="col-6 pr-2">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right"
                            size="sm" class="my-0" />
                    </div>
                </div>
            </div>
        </b-card-code>

        <!-- Add/Edit Modal -->
        <b-modal id="form-modal" size="lg" :title="editId != null ? 'Edit Navbar' : 'Add Navbar'" no-close-on-backdrop>

            <FormInput :id="'title'" :label="'Title'" v-model="formPayload.title" :validation="validations.title"
                :placeholder="'Title'" :required="true" :type="'text'" :modelValue="formPayload.title" />

            <FormSelect id="link_type" label="Link Type" v-model="formPayload.link_type"
                :modelValue="formPayload.link_type" :options="options.linkType" :validation="validations.link_type" />

            <b-form-group v-if="formPayload.link_type == 'page'">
                <label for="page">Page: <span class="text-danger">*</span></label>
                <v-select id="page" v-model="formPayload.page" :options="options.page" :reduce="item => item.uuid"
                    label="name" placeholder="Type here to search page..." @search="onSearchPage">
                    <template slot="no-options">
                        Type here to search page...
                    </template>
                </v-select>
            </b-form-group>

            <b-form-group v-if="formPayload.link_type == 'category'">
                <label for="category">Category: <span class="text-danger">*</span></label>
                <v-select id="category" v-model="formPayload.post_category" :options="options.category"
                    :reduce="item => item.uuid" label="name" placeholder="Type to search category..."
                    @search="onSearchCategory">
                    <template slot="no-options">
                        Type here to search category...
                    </template>
                </v-select>
            </b-form-group>


            <FormInput v-if="formPayload.link_type == 'url'" id="url" label="URL" v-model="formPayload.url"
                :modelValue="formPayload.url" :validation="validations.url" placeholder="URL" :required="true" />

            <b-form-group>
                <div class="d-flex">
                    <label for="is_active" class="mr-1">Is Active: <span class="text-danger">*</span></label>
                    <b-form-checkbox id="is_active" v-model="formPayload.is_active" />
                </div>
            </b-form-group>

            <b-form-group>
                <label for="position">Position: <span class="text-danger">*</span></label>
                <b-form-spinbutton id="position" v-model="formPayload.position" />
            </b-form-group>

            <b-form-group v-if="userData.role == 'admin'">
                <label for="partner">Partner: <span class="text-danger">*</span></label>
                <v-select id="partner" v-model="formPayload.partner" :options="options.partner"
                    :reduce="item => item.uuid" label="name" placeholder="Type to search Partner..."
                    @search="onSearchPartner">
                    <template slot="no-options">
                        Type here to search partner...
                    </template>
                </v-select>
            </b-form-group>

            <template #modal-footer="{}">
                <div v-if="isLoading" class="mb-1">
                    <b-spinner class="mb-2" variant="primary" /><br>
                </div>
                <b-button v-if="editId == null" variant="success" :disabled="isLoading" @click="createItem()">
                    Save Item
                </b-button>
                <b-button v-else variant="success" :disabled="isLoading" @click="updateItem()">
                    Save Item
                </b-button>
            </template>
        </b-modal>
        <!-- Add/Edit Modal -->

    </div>
</template>

<script>
import _ from 'lodash'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
    BCard, BCardText, BButton, BSpinner, BPagination, BFormInput, BFormGroup, BFormCheckbox, BFormSpinbutton
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'

import { successNotification, errorNotification } from '@/auth/utils'
import FormInput from '@/components/FormInput.vue'
import FormSelect from '@/components/FormSelect.vue'
import FormVueSelect from '@/components/FormVueSelect.vue'
import vSelect from 'vue-select'

export default {
    title() {
        return 'Navbar Management'
    },
    components: {
        BCard,
        BButton,
        BCardText,
        BCardCode,
        BSpinner,
        BPagination,
        BFormInput,
        FormInput,
        FormSelect,
        FormVueSelect,
        vSelect,
        BFormGroup,
        BFormCheckbox,
        BFormSpinbutton
    },
    directives: {
        Ripple,
    },
    setup() {
        return { successNotification, errorNotification }
    },
    mixins: [heightTransition],
    watch: {
        currentPage: {
            handler: _.debounce(function (value) {
                this.getData(value);
            }, 300),
            deep: true,
        },
        filter: {
            handler: _.debounce(function (value) {
                this.getData();
            }, 300),
            deep: true,
        }
    },
    data() {
        const userData = JSON.parse(localStorage.getItem('userData'))
        return {
            userData,
            // Pagination
            currentPage: 1,
            totalRows: 0,
            perPage: 10,
            itemCount: 0,
            totalItems: 0,
            pageOptions: [3, 5, 10],

            options: {
                linkType: [
                    { value: null, text: 'Please select an option' },
                    { value: 'category', text: 'Category' },
                    { value: 'page', text: 'Page' },
                    { value: 'url', text: 'URL' },
                ],
                category: [],
                page: [],
                partner: []
            },

            result: Object,
            isLoading: false,
            formPayload: {
                title: '',
                link_type: null,
                post_category: '',
                page: '',
                url: '',
                is_active: false,
                position: 1,
                partner: '',
            },
            editId: null,
            filter: {
                search: '',
            },
            validations: {},
        }
    },
    mounted() {
        this.getData()
        this.getCategory()
        this.getPages()
        this.getPartner()
    },
    created() {
    },
    destroyed() {
    },
    methods: {
        // Partner
        onSearchPartner(search, loading) {
            if (search.length) {
                loading(true)
                this.searchPartner(loading, search, this)
            }
        },
        searchPartner: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/partners?&search=${encodeURI(search)}`)
                .then(response => {
                    vm.options.partner = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getPartner() {
            if (this.userData.role == 'admin') {
                this.$http.get('/admin/partners', {
                }).then((result) => {
                    this.options.partner = result.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                }).catch((err) => {

                });
            }
        },
        // Search category
        onSearchCategory(search, loading) {
            if (search.length) {
                loading(true)
                this.searchCategory(loading, search, this)
            }
        },
        searchCategory: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/post-categories?search=${encodeURI(search)}`)
                .then(response => {
                    vm.options.category = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getCategory() {
            this.$http.get(`admin/post-categories`)
                .then(response => {
                    this.options.category = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.name,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
        },
        // Search page
        onSearchPage(search, loading) {
            if (search.length) {
                loading(true)
                this.searchPage(loading, search, this)
            }
        },
        searchPage: _.debounce((loading, search, vm) => {
            vm.$http.get(`admin/pages?search=${encodeURI(search)}`)
                .then(response => {
                    vm.options.page = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.title,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
            loading(false)
        }, 300),
        getPages() {
            this.$http.get(`admin/pages`)
                .then(response => {
                    this.options.page = response.data.data.items.map(obj => ({
                        uuid: obj._id,
                        name: obj.title,
                    }))
                })
                .catch(error => {
                    console.error(error)
                })
        },
        cleanUpForm() {
            this.editId = null
            this.formPayload = {
                title: '',
                link_type: null,
                post_category: '',
                page: '',
                url: '',
                is_active: '',
                position: '',
                partner: '',
            }
        },
        getData(page = 1) {
            this.isLoading = true
            this.currentPage = page
            const queryParams = this.filter
            queryParams.page = this.currentPage

            this.$http.get('/admin/navbar', {
                params: queryParams,
            })
                .then(response => {
                    const data = response.data.data;
                    this.result = data;
                    this.itemCount = data.meta.item_count;
                    this.totalItems = data.meta.total_items;
                    this.currentPage = data.meta.current_page;
                    this.totalRows = data.meta.total_items;
                    this.isLoading = false;
                })
        },
        createItem() {
            const qs = require('qs')
            const form = qs.stringify(this.formPayload)

            this.$http.post('/admin/navbar', form, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
                .then(response => {
                    this.$bvModal.hide('form-modal')
                    this.getData(this.currentPage)
                    successNotification(this, 'Success', 'Navbar successfully created')
                    this.cleanUpForm()
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        updateItem() {
            const qs = require('qs')
            const form = qs.stringify(this.formPayload)

            this.$http.patch(`/admin/navbar/${this.editId}`, form, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
                .then(response => {
                    this.$bvModal.hide('form-modal')
                    this.getData(this.currentPage)
                    successNotification(this, 'Success', 'Navbar successfully updated!')
                    this.cleanUpForm()
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        preparePayload() {
            const form = new FormData()

            // eslint-disable-next-line no-restricted-syntax
            for (const key in this.formPayload) {
                if (this.formPayload.hasOwnProperty(key) && this.formPayload[key] != null && this.formPayload[key] != '') {
                    // Handle if this.formPayload[key] is array
                    form.append(key, this.formPayload[key])
                }
            }

            return form
        },
        editItem(item) {
            this.editId = item._id
            this.formPayload = {
                title: item.title,
                link_type: item.link_type,
                post_category: item.post_category?._id,
                page: item.page?._id,
                url: item.url,
                is_active: item.is_active,
                position: item.position,
                partner: item.partner?._id,
            }

            this.$bvModal.show('form-modal')
        },
        deleteItem(id) {
            this.$swal({
                title: 'Are you sure?',
                text: 'Are you sure to delete this navbar?',
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    this.$http.delete(`admin/navbar/${id}`)
                        .then(response => {
                            this.getData(this.currentPage)
                            this.$swal({
                                icon: 'success',
                                title: 'Success!',
                                text: 'Navbar successfully deleted',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                },
                            })
                        })
                        .catch(error => {
                            const validations = error.response.data.meta.validations
                            const messages = error.response.data.meta.messages
                            // this.validations = validations
                            if (validations) {
                                for (const key in validations) {
                                    if (validations.hasOwnProperty(key)) {
                                        errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                                    }
                                }
                            }
                            if (messages) {
                                errorNotification(this, 'Oops!', messages)
                            }
                        })
                }
            })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
    overflow: hidden;
    transition: .35s height;
}
</style>
